export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Comment.vue?vue&type=template&id=133ed8df&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment.vue?vue&type=template&id=133ed8df&
// module id = 536
// module chunks = 3